
<button *ngIf="displayCustomAddressButton"
        mat-button
        (click)="setCustomValue()"
        matTooltip="Usare solo se non viene trovato l'indirizzo da Google Maps"
        [matTooltipPosition]="'right'"
        mat-stroked-button
        color="primary"
        style="margin-bottom: 10px" >
  Usa comunque questo indirizzo
</button>

<mat-form-field>
  <input matInput #search [placeholder]="placeholder" [value]="valueFunction()" [disabled]="disabled" [formControl]="addressControl">
  <mat-icon matSuffix>location_on</mat-icon>
</mat-form-field>

<div class="map-container">
  <!-- <agm-map [latitude]="value ? value.latitude : defaultLat"
           [longitude]="value ? value.longitude : defaultLng"
           [scrollwheel]="false"
           [zoom]="defaultZoom"
           >

    <agm-polygon
           [paths]="polygon"
           fillColor="green"
           fillOpacity="0.15"
           strokeColor="black"
           strokeOpacity="0.5"
           strokeWeight="2"
           zIndex="1">
    </agm-polygon>

    <agm-marker
      [latitude]="defaultLat"
      [longitude]="defaultLng"
      iconUrl="assets/icons/markers/birgo_marker.png"
    >

      <agm-info-window>
          <h3>Birgo Burger</h3>
      </agm-info-window>
    </agm-marker>

    <agm-marker *ngIf="value" [latitude]="value.latitude" [longitude]="value.longitude">
        <agm-info-window>
          <h3>{{ value.formattedAddress }}</h3>
        </agm-info-window>
    </agm-marker>

  </agm-map> -->
  <app-spinner *ngIf="loading$ | async" class="absolute-spinner"></app-spinner>
</div>
